export default {
  screens: [
    {
      type: 'intro',
      title: 'Chaumet and Japan',
      content:
        'Chaumet’s fascination for the Japanese archipelago goes back to the origins of the Maison. The curiosity is reciprocal as many Japanese customers have chosen Chaumet. ',
      idYt: 'vGycDLMlTz4',
      videoCover: 'world/japan/video.jpg',
      desktop: {
        cover: 'world/japan/cover-1.jpg'
      },
      mobile: {
        cover: 'world/japan/mobile-cover-1.jpg',
        contentStyle: {
          width: '100%'
        },
        coverStyle: {
          width: '100%',
          bottom: '0%',
          left: '0',
          right: 'inherit',
          position: 'relative'
        }
      }
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/japan/triangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg',
        cover: 'world/japan/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/japan/mobileTriangleTop.jpg',
        btmImg: 'world/japan/triangleBtm.jpg'
      },
      content:
        "The wonder of Nitot in front of Queen Marie Antoinette's lacquers, then Joséphine's passion for Japanese varieties, are founding elements. Since then the Maison has never ceased to be inspired by Japan for its creations.<br/><br/>A High Jewellery collection dedicated to Japan displays this connection in true majesty."
    },
    {
      type: 'column',
      leftImg: 'world/japan/columnLeft.jpg',
      middleImg: 'world/japan/columnMiddle.jpg',
      rightImg: 'world/japan/columnRight.jpg',
      title: 'Song of Spring',
      content:
        'The set of jewellery diffuses the very essence of Japanese culture with bright colours of ink and lacquer, the rebirth of nature combined with geometric purity. '
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/japan.js